// import * as React from 'react';
// import { Button } from "@progress/kendo-react-buttons";
// import styled from "styled-components";

// import Popup from "../components/CusPopup";

// const ButtonToggle = styled(Button)`
// color: blue;
// opacity: 0.7;
// background-color: transparent;
// background-repeat: no-repeat;
// border: none;
// margin-top: -0.4em;
// margin-left: -0.4em;
// &:hover {
//     background-color: transparent;
//   }
// ${({ active }) =>
//         active &&
//         `
// opacity: 1; 
// `}
// `;

// let showPopup = false;
// const SaveAndContinue = (props) => {
 
//     const onHandleClick = React.useCallback(
//         (e) => {
//             console.log('do api call here');
//             showPopup = false;
//             console.log('showpop',showPopup)
//             props.pTrigger = true;
//         },
//         []
//     )

//     return (
//         <div style={{ textAlign: 'center' }}>
//             <Popup
//                 trigger={props.pTrigger}
//                 className="popUpBox" >
//                 <div style={{ textAlign: "center" }}>
//                     <p>Your application is on hold.<br/>
//                         Do complete your application before DDMMYYYY to avoid reapplying.
//                         Refer to your email for more information.
//                     </p>
//                 </div>
//                 <br />
//                 <div className="row">
//                     <div className="col-12" style={{ textAlign: "center" }}>
//                         <Button
//                             look="outline"
//                             className="sccbTxt2"
//                             style={{ width: "10rem" }}
//                             onClick={onHandleClick}>
//                             Back to Home
//                         </Button>
//                     </div>
//                 </div>
//             </Popup>
//         </div>
//     )
// }


// export default SaveAndContinue;

import React, { useState } from "react";
import './Popup.css';
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import { Button } from "@progress/kendo-react-buttons";

function SaveAndContinue(props) {
  const CloseModalButton = styled(MdClose)`
    color: white;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    //padding: 0;
    // z-index: 10;
    //top: 16px;
  `;

      const onHandleClick = React.useCallback(
        (e) => {
            props.setTrigger(false);
        },
        []
    )

  return props.trigger ?(
    <div className="popup">
      <div className="popup-inner">
                <div style={{ textAlign: "center" }}>
                    <p>Your application is on hold.<br/>
                        Do complete your application before DDMMYYYY to avoid reapplying.
                        Refer to your email for more information.
                    </p>
                 </div>
             <br />
                 <div className="row">
                      <div className="col-12" style={{ textAlign: "center" }}>
                         <Button
                              look="outline"
                             className="sccbTxt2"
                             style={{ width: "10rem" }}
                             onClick={onHandleClick}>
                             Back to Home
                       </Button>
                    </div>
                  </div>
      </div>
    </div>
  ) : (
    ""
  );
}

export default SaveAndContinue;
